<div class="container-sm">
    <h1 class="m-3 display-6 vm-container-header"><i class="bi bi-file-code me-2"></i> 997 Config</h1>

    <div class="pb-5">
        <div class="bg-body-light rounded-3 shadow">
            <div class="m-2 pb-1">
                <form autocomplete="off">
                    <div class="mb-3 mx-0 row align-items-center">
                        <app-table-search [(value)]="this.service.searchTerm" />
                    </div>
                </form>

                @if ((this.total$ | async) ?? 0) {
                    <table class="table table-striped table-hover">
                        <caption>{{ this.total$ | async }} Total</caption>

                        <thead>
                        <tr>
                            <th scope="col" sortable="versionNotes" (sort)="this.onSort($event)">Version Notes</th>
                            <th scope="col" class="text-center" sortable="isActive" (sort)="this.onSort($event)">
                                Is Active
                            </th>
                            <th scope="col" sortable="createdBy" (sort)="this.onSort($event)">Created By</th>
                            <th scope="col" sortable="createdAt" (sort)="this.onSort($event)">Created At</th>
                            <th scope="col" class="text-center">Actions</th>
                        </tr>
                        </thead>

                        <tbody class="table-group-divider">
                            @for (element of this.configs$ | async; track element.id; ) {
                                <tr>
                                    <td class="align-middle text-ellipsis" title="{{ element.versionNotes }}"
                                        style="max-width: 20em;">
                                        {{ element.versionNotes }}
                                    </td>
                                    <td class="align-middle text-center">
                                        @if (element.isActive) {
                                            <span class="badge text-bg-success"><i class="bi bi-check-lg"></i></span>
                                        }
                                    <td class="align-middle">{{ element.createdBy }}</td>
                                    <td class="align-middle">{{ this.longFormatDate(element.createdAt) }}</td>
                                    <td class="align-middle text-center">
                                        <div class="btn-group">
                                            <i class="btn btn-sm btn-outline-primary bi bi-search"
                                               title="View details"
                                               (click)="onView(element.id)"></i>
                                            <i class="btn btn-sm btn-outline-primary bi bi-pencil"
                                               title="Create a new config based on this one"
                                               (click)="onEdit(element.id)"></i>
                                            <i class="btn btn-sm btn-outline-primary bi bi-upload"
                                               title="Publish this config to make it the active config"
                                               (click)="onPublish(element.id)"></i>
                                        </div>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>

                    <app-table-pager [total]="(this.total$ | async)!" [(page)]="this.service.page" [(pageSize)]="this.service.pageSize" />
                }

                @if (((this.total$ | async) ?? 0) == 0 && !(this.globalService.waitOverlayIsVisible$ | async)) {
                    <div class="card text-center bg-warning-subtle border border-warning rounded p-3 m-5">
                        <div class="card-body">
                            <i class="bi bi-exclamation-triangle-fill me-2"></i>No 997 configs found.
                        </div>
                    </div>
                }
            </div>
        </div>


        <ng-template #editModal>
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="editModalLabel">
                    Create New 997 Config
                </h1>
                <button (click)="closeEditModal()" aria-label="Close" class="btn-close" type="button"></button>
            </div>

            <form [formGroup]="editForm" autocomplete="off">
                <div class="modal-body">
                    @if ((loadingDetails$ | async)) {
                        <div class="text-center p-3">
                            <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <p class="mt-2">Loading details...</p>
                        </div>
                    }

                    @if (!(loadingDetails$ | async)) {
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control" id="versionNotes" formControlName="version_notes"
                                   placeholder="Version notes">
                            <label for="versionNotes">Version Notes</label>
                        </div>

                        <div formArrayName="connectors">
                            <h4 class="mt-4 mb-3">Configuration Settings</h4>

                            @if (connectors.controls.length === 0) {
                                <div class="alert alert-info">
                                    No configuration settings added. Click "Add Setting" to add a new setting.
                                </div>
                            }

                            @for (control of connectors.controls; track control; let i = $index) {
                                <div [formGroupName]="i" class="card mb-3">
                                    <div class="card-header d-flex justify-content-between align-items-center">
                                        <h5 class="mb-0">Setting #{{ i + 1 }}</h5>
                                        <button type="button" class="btn btn-sm btn-outline-danger"
                                                (click)="removeConnector(i)">
                                            <i class="bi bi-trash"></i> Remove
                                        </button>
                                    </div>
                                    <div class="card-body">
                                        <div class="form-floating mb-3">
                                            <input type="text" class="form-control" id="name{{i}}"
                                                   formControlName="name"
                                                   placeholder="Setting name">
                                            <label for="name{{i}}">Name</label>
                                        </div>
                                        <div class="form-floating mb-3">
                                            <select class="form-select" id="outbound_connector_id{{i}}"
                                                    formControlName="outbound_connector_id">
                                                <option value="">Select a connector</option>
                                                @for (connector of availableConnectors; track connector.connectorId) {
                                                    <option [value]="connector.connectorId">{{ connector.name }}
                                                    </option>
                                                }
                                            </select>
                                            <label for="outbound_connector_id{{i}}">Outbound Connector ID</label>
                                        </div>
                                        <div class="form-floating mb-3">
                                            <input type="text" class="form-control" id="outbound_folder{{i}}"
                                                   formControlName="outbound_folder" placeholder="Outbound Folder">
                                            <label for="outbound_folder{{i}}">Outbound Folder</label>
                                        </div>
                                        <div class="form-floating mb-3">
                                            <input type="text" class="form-control" id="sender_ids{{i}}"
                                                   formControlName="sender_ids" placeholder="Sender IDs">
                                            <label for="sender_ids{{i}}">Sender IDs <span
                                                class="badge text-bg-secondary fw-normal">comma separated</span></label>
                                        </div>
                                        <div class="form-floating mb-3">
                                            <input type="text" class="form-control" id="receiver_ids{{i}}"
                                                   formControlName="receiver_ids" placeholder="Receiver IDs">
                                            <label for="receiver_ids{{i}}">Receiver IDs <span
                                                class="badge text-bg-secondary fw-normal">comma separated</span></label>
                                        </div>
                                    </div>
                                </div>
                            }

                            <div class="d-grid gap-2 mt-3">
                                <button type="button" class="btn btn-outline-primary" (click)="addConnector()">
                                    <i class="bi bi-plus-circle"></i> Add Setting
                                </button>
                            </div>
                        </div>
                    }
                </div>

                <div class="modal-footer">
                    <button (click)="this.onSave(false)" [disabled]="savingData || editForm.invalid"
                            class="btn btn-primary"
                            title="Save the config and leave it inactive">
                        <span [ngClass]="{'spinner-border spinner-border-sm me-1': savingData, '': !savingData}"></span>
                        Save
                    </button>
                    <button (click)="this.onSave(true)" [disabled]="savingData || editForm.invalid"
                            class="btn btn-primary"
                            title="Save the config and immediately publish it to make it active">
                        <span [ngClass]="{'spinner-border spinner-border-sm me-1': savingData, '': !savingData}"></span>
                        Save & Publish
                    </button>
                    <button (click)="closeEditModal()" class="btn btn-secondary" type="button">Close</button>
                </div>
            </form>
        </ng-template>
    </div>

    <ng-template #viewDetailsModal>
        <div class="modal-header">
            <h1 class="modal-title fs-5" id="viewDetailsModalLabel">
                997 Config Details
            </h1>
            <button (click)="closeViewModal()" aria-label="Close" class="btn-close" type="button"></button>
        </div>
        <div class="modal-body">
            @if ((loadingDetails$ | async)) {
                <div class="text-center p-3">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2">Loading details...</p>
                </div>
            }

            @if (!(loadingDetails$ | async) && (configDetails$ | async)) {
                <div class="mb-4">
                    <h4>General Information</h4>
                    <div class="table-responsive">
                        <table class="table table-sm table-hover">
                            <tbody>
                            <tr>
                                <th scope="row" style="width: 30%">Version Notes</th>
                                <td>{{ (configDetails$ | async)!.versionNotes }}</td>
                            </tr>
                            <tr>
                                <th scope="row">Is Active</th>
                                <td>{{ (configDetails$ | async)!.isActive ? 'Yes' : 'No' }}</td>
                            </tr>
                            <tr>
                                <th scope="row">Created By</th>
                                <td>{{ (configDetails$ | async)!.createdByAdminUser }}</td>
                            </tr>
                            <tr>
                                <th scope="row">Created At</th>
                                <td>{{ longFormatDate((configDetails$ | async)!.createdAt) }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                @if (!!(configDetails$ | async)!.configSettings) {
                    <h4>Configuration Settings</h4>
                    @for (settingKey of Object.keys((configDetails$ | async)!.configSettings); track settingKey) {
                        <div class="card mb-3">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <h5 class="mb-0">{{ settingKey }}</h5>
                            </div>
                            <div class="card-body">
                                <div class="card-text table-responsive">
                                    <table class="table table-sm table-hover config-settings">
                                        <tbody>
                                        <tr>
                                            <th scope="row" style="width: 30%">Outbound Connector ID</th>
                                            <td>{{ (configDetails$ | async)!.configSettings[settingKey].outbound_connector_id }}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Outbound Folder</th>
                                            <td>{{ (configDetails$ | async)!.configSettings[settingKey].outbound_folder }}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Sender IDs</th>
                                            <td>
                                                {{ (configDetails$ | async)!.configSettings[settingKey].sender_ids.join(', ') }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Receiver IDs</th>
                                            <td>
                                                {{ (configDetails$ | async)!.configSettings[settingKey].receiver_ids.join(', ') }}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    }
                }

                @if (!(configDetails$ | async)!.configSettings || Object.keys((configDetails$ | async)!.configSettings).length === 0) {
                    <div class="alert alert-info">
                        No configuration settings found.
                    </div>
                }
            }
        </div>
        <div class="modal-footer">
            <button (click)="closeViewModal()" class="btn btn-secondary" type="button">Close</button>
        </div>
    </ng-template>

    <app-modal-confirm #confirmationModal></app-modal-confirm>
</div>
